import { lazy } from '@/service/lazy'

export default [{
  name: 'Sem ações',
  path: 'sem-acoes',
  icon: '',
  id: 'sem-acoes',
  component: lazy('app/default/erro/sem-acoes'),
  meta: { requireAuth: true },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/semacoes.js